const state = {
  cacheEx: [],
  notFound: [],
};

const mutations = {
  GET_CACHE_EX(state) {
    return state.cacheEx;
  },

  SET_CACHE_EX(state, items) {
    state.cacheEx = items;
  },

  GET_NOT_FOUND(state) {
    return state.notFound;
  },

  SET_NOT_FOUND(state, ncm) {
    state.notFound = [...state.notFound, ncm];
  },
};

const actions = {
  getCacheEx({ commit }) {
    commit("GET_CACHE_EX");
  },

  setCacheEx({ commit }, exec) {
    commit("SET_CACHE_EX", exec);
  },

  getNotFound({ commit }) {
    commit("GET_NOT_FOUND");
  },

  setNotFound({ commit }, ncm) {
    commit("SET_NOT_FOUND", ncm);
  },
};

const getters = {
  getCacheEx: (state) => state.cacheEx,
  getNotFound: (state) => state.notFound,
};

const module = {
  state,
  mutations,
  actions,
  getters,
};

export default module;
